export default __webpack_public_path__ + "logo058ae40d.png";